export interface PurchaseOrderLinePurchasesAllocationsSummaryTop {
  productKey: string;
  productDescription: string;
  quantity: number;
  allocated: number;
  currencySymbol: string;
  price: number;
  deliveryDate: Date;
}
